import React from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt } from '@fortawesome/pro-light-svg-icons/faShieldAlt';
import { faUserLock } from '@fortawesome/pro-light-svg-icons/faUserLock';
import { faFingerprint } from '@fortawesome/pro-light-svg-icons/faFingerprint';
import LinkButton from '../common/Buttons/LinkButton';
import SaveEditSwitcher from './SaveEditSwitcher';

class SecurityInfoArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inEditMode: false,
    };
  }

  toggleEditMode = () => {
    const { inEditMode } = this.state;

    this.setState({
      inEditMode: !inEditMode,
    });
  };

  render() {
    const { inEditMode } = this.state;
    const { mfaEnabled, onChangePasswordClick, onDisableMfaClick, onEnableMfaClick, t, isAdmin } = this.props;
    const securityInfoClasses = classnames('settings-list', { editing: inEditMode });

    return (
      <div className={securityInfoClasses}>
        <SaveEditSwitcher
          icon={faShieldAlt}
          title={t('labelSecuritySettings')}
          onEditClick={this.toggleEditMode}
          onSaveClick={this.toggleEditMode}
          inEditMode={inEditMode}
          buttons={{
            save: t('labelDone'),
            edit: t('labelEdit'),
          }}
        />
        <div className="settings-list__item">
          <span className="label">
            <FontAwesomeIcon icon={faUserLock} />
            {t('labelPassword')}
          </span>
          <span className="value">********</span>
          <span className="input">
            <LinkButton onClick={onChangePasswordClick}>{t('labelChangePassword')}</LinkButton>
          </span>
        </div>
        <div className="settings-list__item">
          <span className="label">
            <FontAwesomeIcon icon={faFingerprint} />
            {t('labelMfaStatus')}
          </span>
          <span className="value">{mfaEnabled ? t('labelEnabled') : t('labelDisabled')}</span>
          {mfaEnabled ? (
            <span className="input">
              <LinkButton disabled className="as-link" onClick={onDisableMfaClick}>
                {t('labelDisableMfa')}
              </LinkButton>
            </span>
          ) : (
            <span className="input">
              <LinkButton disabled={isAdmin} className="as-link" onClick={onEnableMfaClick}>
                {t('labelEnableMfa')}
              </LinkButton>
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default SecurityInfoArea;
